import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  FunctionComponent,
  PropsWithChildren,
  ReactNode
} from 'react';
// import { getCurrentAuthenticatedUser } from '../auth/redux-utils/actions';
// import { useDispatch } from 'react-redux';
import { useLocalStorage } from '@futrli/shared-services';
import { IS_SSO_EMBED_USER_KEY } from './constants';
import { clearLocalStorageWithExceptions } from '@futrli/shared-services/string-utils/utils';

// FIXME: Need to add this integration constant as an environment variable.
// TODO: Make this a list
const SSO_EMBED_INTEGRATION_IDS = 'sso-embed-test-int-id';

interface SSOEmbedContextType {
  integrationId: string;
  setIntegrationId: ((_s: string) => void) | null;

  ssoEmbedRestricted: boolean;
}

const defaultSSOEmbedContext: SSOEmbedContextType = {
  integrationId: '',
  setIntegrationId: null,
  ssoEmbedRestricted: true
};

export const SSOEmbedContext = createContext<SSOEmbedContextType>(defaultSSOEmbedContext);

export const useSSOEmbedContext = () => useContext<SSOEmbedContextType>(SSOEmbedContext);

export const SSOEmbedProvider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
  const [integrationId, setIntegrationId] = useState(SSO_EMBED_INTEGRATION_IDS);
  const [ssoEmbedRestricted, setSsoEmbedRestricted] = useState<boolean>(false);
  const [ssoEmbededUser, ,] = useLocalStorage<string>(IS_SSO_EMBED_USER_KEY, 'false');
  // const dispatch = useDispatch();

  useEffect(() => {
    // Whenever the integration id is set, check it here to determine if we are disabling features or not.
    if (integrationId === SSO_EMBED_INTEGRATION_IDS) {
      setSsoEmbedRestricted(true);
    } else {
      setSsoEmbedRestricted(false);
    }
  }, [integrationId]);

  // TODO: Add this later.  We will need to get user info for the landing page.
  // const getUser = async () => {
  //   return await getCurrentAuthenticatedUser()(dispatch);
  // }

  useEffect(() => {
    // TODO: The user will be used later.
    // const user = getUser().then((u) => console.log(u))
    if (window.self !== window.top) {
      // App is running inside an iframe
      // Clear the storage every time so forced to re-authenticate.
      clearLocalStorageWithExceptions();
      sessionStorage.clear();
    } else {
      // App is not running in an iframe.
      // Need to check if the session was an SSO embedded user session.
      if (ssoEmbededUser === 'true') {
        clearLocalStorageWithExceptions();
        sessionStorage.clear();
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SSOEmbedContext.Provider
      value={{
        integrationId,
        setIntegrationId,
        ssoEmbedRestricted
      }}
    >
      {children}
    </SSOEmbedContext.Provider>
  );
};

const SSOEmbedCheck = ({ children }: { children: ReactNode }) => {
  const { ssoEmbedRestricted } = useSSOEmbedContext();

  if (ssoEmbedRestricted) {
    return <></>;
  }

  return <>{children}</>;
};

export default SSOEmbedCheck;
